import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

export const NotFound = () => {
  return (
    <main className="bodyContent notFoundPage">
      <section className="notFoundContent">
        <p className="notFoundCode">404</p>
        <h1>Page Not Found</h1>
        <p className="notFoundMessage">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="notFoundActions">
          <Link className="notFoundPrimaryLink" to="/">
            Back to Home
          </Link>
          <Link className="notFoundSecondaryLink" to="/contact-us">
            Contact Us
          </Link>
        </div>
      </section>
    </main>
  );
};
